<!--
 * @Author: wh
 * @Date: 2020-08-24 19:10:33
 * @LastEditTime: 2020-09-13 15:42:55
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \Web\JiYun.Mobile\src\views\leaderTerminal\DataBulletin\accountsReceive.vue
-->
<template>
    <div class="accountsReceive">
        <div class="search-conditions-con">
            <div class="search-conditions">
                <span class="time-con" @click="handleShowCalendar(1, date1)">
                    <span>{{ date1 }}</span>
                </span>
                <span>-</span>
                <span class="time-con time-con2" @click="handleShowCalendar(2, date2)">
                    <span>{{ date2 }}</span>
                </span>
                <span class="org" @click="showOrgPop=true">
                    <span class="org-name">{{ orgName }}</span>
                </span>
            </div>
            <!-- <div class="search-conditions" style="margin-top: 10px;">
                <span class="org" @click="showOrgPop=true">
                    <span class="org-name">{{ orgName }}</span>
                </span>
            </div> -->
        </div>

        <div class="main">
            <div class="top">
                <h4>累计金额<span>(万元)</span></h4>
                <div class="header">
                    <div class="item item0">
                        <p class="num">
                            {{ sumData.loans_receivable }}
                        </p>
                        <p class="describe">
                            累计主收
                        </p>
                    </div>
                    <div class="item item1">
                        <p class="num">
                            {{ sumData.official_receipt }}
                        </p>
                        <p class="describe">
                            累计实收
                        </p>
                    </div>
                    <div class="item item2">
                        <p class="num">
                            {{ sumData.ending_balance_receivable }}
                        </p>
                        <p class="describe">
                            应收账款余额
                        </p>
                    </div>
                    <div class="item item2">
                        <p class="num">
                            {{ sumData.overdue_arrears }}
                        </p>
                        <p class="describe">
                            逾期账款
                        </p>
                    </div>
                </div>
            </div>
            <div class="split"></div>
            <div class="chart-con">
                <h4>应收账款余额</h4>
                <div id="lineChart"></div>
            </div>
            <div class="split"></div>
            <div class="chart-con">
                <h4>货款回收率</h4>
                <div id="lineChart2"></div>
            </div>
        </div>
        <van-popup v-model="showCalendarPop" position="bottom" :style="{ height: '50%' }">
            <van-datetime-picker
                v-model="currentDate"
                type="year-month"
                title="选择年月日"
                @confirm="confirmDate"
                @cancel="cancelDate"
            ></van-datetime-picker>
        </van-popup>
        <van-popup v-model="showOrgPop" position="bottom" :style="{ height: '50%' }">
            <van-picker
                show-toolbar
                title="请选择"
                :columns="columns"
                @confirm="confirmOrg"
                @cancel="cancelOrg"
            ></van-picker>
        </van-popup>
    </div>
</template>

<script>
import bg_green from '@/assets/images/home/bg_green.png';
import bg_yellow from '@/assets/images/home/bg_yellow.png';
export default {
    components: {},
    props: {},
    data() {
        return {
            // 选择时间
            showCalendarPop: false,
            // 选择组织结构
            showOrgPop: false,
            // 当前日期
            date1: '',
            date2: '',
            // 选中组织结构
            orgName: '全部',
            columns: [
                {
                    text: '全部',
                    children: [],
                },
            ],
            // 图表数据
            data: {},
            sumData: {},
            // 组织机构
            orgData: [],
            dic_code: '',
            pian_q_id: '',
            yun_yq_id: '',
            currentDate: '',
            // 选中表格行index
            activeRow: -1,
            // tab选项
            tabData: [
                {
                    name: '按标号',
                    disabled: false,
                },
                {
                    name: '按场站/线',
                    disabled: false,
                },

                {
                    name: '按分类',
                    disabled: false,
                },
            ],
            tabActive: 0,
            timeType: 1,
        };
    },
    watch: {},
    computed: {},
    created() {},
    mounted() {
        this.init();
    },
    methods: {
        // 返回上一页
        onClickLeft() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },
        init() {
            const date = new Date();
            const year = date.getFullYear();
            let month = date.getMonth() + 1;
            this.date1 = year + '-01';
            month = month < 10 ? '0' + month : month;
            this.date2 = year + '-' + month;
            this.getSaleday();
            this.getOrg();
        },
        handleShowCalendar(type, date) {
            const arr = date.split('-');
            this.currentDate = new Date(arr[0], arr[1] - 1, 1);
            this.timeType = type;
            this.showCalendarPop = true;
        },
        async getOrg() {
            const yyq = await this.getOrgApi();
            if (yyq) {
                const res = yyq.map(item => {
                    item.text = item.dic_name;
                    if (item.children) {
                        item.children = item.children.map(v => {
                            v.text = v.dic_name;
                            return v;
                        });
                    } else {
                        item.children = [];
                    }
                    return item;
                });
                this.orgData = res;
                this.columns[0].children = this.orgData;
            }
        },
        // 获取组织结构    
        getOrgApi() {
            const path = '/interfaceApi/report/dictionary/get_dictionary_tree?group_code=jt_data_express_tenant&isAddSelect=true';
            return this.$axios.$get(path, { defEx: true });
        },
        async getSaleday() {
            const res = await this.getSaledayApi();
            if (res) {
                this.data = res;
                this.sumData = this.data[0];
                this.sumData.loans_receivable = (this.sumData.loans_receivable / 10000).toFixed(2);
                this.sumData.official_receipt = (this.sumData.official_receipt / 10000).toFixed(2);
                this.sumData.ending_balance_receivable = (this.sumData.ending_balance_receivable / 10000).toFixed(2);
                res.shift();
                const xData = [];
                // 累计应收
                const loansReceivable = [];
                // 累计实收
                const officialReceipt = [];
                // 应收账款余额
                const endingBalanceReceivable = [];
                // 货款回收率
                const balanceReceivableRate = [];
                res.map(item => {
                    xData.push(item.month);
                    loansReceivable.push((item.loans_receivable / 10000).toFixed(2));
                    officialReceipt.push((item.official_receipt / 10000).toFixed(2));
                    endingBalanceReceivable.push((item.ending_balance_receivable / 10000).toFixed(2));
                    balanceReceivableRate.push(item.balance_receivable_rate);
                });
                const data1 = {
                    id: 'lineChart',
                    xData: xData,
                    legend: ['本月主收', '本月实收', '月应收账款余额'],
                    yAxisName: ['万元', '万元'],
                    grid: {
                        left: 50,
                        top: 60,
                        right: 50,
                        bottom: 40,
                    },
                    series: [
                        {
                            name: '本月主收',
                            type: 'bar',
                            itemStyle: {
                                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                    offset: 0,
                                    color: 'rgba(113,198,176,1)', // 0% 处的颜色
                                }, {
                                    offset: 1,
                                    color: 'rgba(78,164,150,1)', // 100% 处的颜色
                                }], false),
                            },
                            label: {
                                show: false,
                                position: 'top',
                                fontSize: '12',
                                color: 'rgba(78,164,150,1)',
                                lineHeight: 22,
                                padding: [0, 10, 4, 10],
                                backgroundColor: {
                                    image: bg_green,
                                },
                            },
                            barMaxWidth: 15,
                            data: loansReceivable,
                        },
                        {
                            name: '本月实收',
                            type: 'bar',
                            itemStyle: {
                                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                    offset: 0,
                                    color: 'rgba(242,227,65,1)', // 0% 处的颜色
                                }, {
                                    offset: 1,
                                    color: 'rgba(220,193,41,1)', // 100% 处的颜色
                                }], false),
                            },
                            label: {
                                show: false,
                                position: 'top',
                                fontSize: '12',
                                color: 'rgba(220,193,41,1)',
                                lineHeight: 22,
                                padding: [0, 10, 4, 10],
                                backgroundColor: {
                                    image: bg_yellow,
                                },
                            },
                            barMaxWidth: 15,
                            data: officialReceipt,
                        },
                        {
                            name: '月应收账款余额',
                            type: 'line',
                            itemStyle: {
                                normal: {
                                    color: '#FA8436',
                                    lineStyle: {
                                        color: '#FA8436',
                                    },
                                },
                            },
                            label: {
                                show: false,
                                position: 'bottom',
                                fontSize: '12',
                                padding: 0,
                                color: '#FA8436',
                            },
                            yAxisIndex: 1,
                            data: endingBalanceReceivable,
                        },
                    ],
                };
                const data2 = {
                    id: 'lineChart2',
                    xData: xData,
                    legend: ['本月主收', '本月实收', '月货款回收率'],
                    yAxisName: ['万元', '%'],
                    grid: {
                        left: 50,
                        top: 60,
                        right: 30,
                        bottom: 40,
                    },
                    series: [
                        {
                            name: '本月主收',
                            type: 'bar',
                            itemStyle: {
                                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                    offset: 0,
                                    color: 'rgba(85,167,254,1)', // 0% 处的颜色
                                }, {
                                    offset: 1,
                                    color: 'rgba(62,121,197,1)', // 100% 处的颜色
                                }], false),
                            },
                            label: {
                                show: false,
                                position: 'top',
                                fontSize: '12',
                                color: 'rgba(62,121,197,1) ',
                                lineHeight: 22,
                                padding: [0, 10, 4, 10],
                                backgroundColor: {
                                    image: bg_green,
                                },
                            },
                            barMaxWidth: 15,
                            data: loansReceivable,
                        },
                        {
                            name: '本月实收',
                            type: 'bar',
                            itemStyle: {
                                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                    offset: 0,
                                    color: 'rgba(239,171,84,1)', // 0% 处的颜色
                                }, {
                                    offset: 1,
                                    color: 'rgba(250,140,71,1)', // 100% 处的颜色
                                }], false),
                            },
                            label: {
                                show: false,
                                position: 'top',
                                fontSize: '12',
                                color: 'rgba(250,140,71,1) ',
                                lineHeight: 22,
                                padding: [0, 10, 4, 10],
                                backgroundColor: {
                                    image: bg_yellow,
                                },
                            },
                            barMaxWidth: 15,
                            data: officialReceipt,
                        },
                        {
                            name: '月货款回收率',
                            type: 'line',
                            itemStyle: {
                                normal: {
                                    color: '#21BC9A',
                                    lineStyle: {
                                        color: '#21BC9A',
                                    },
                                },
                            },
                            label: {
                                show: false,
                                position: 'bottom',
                                fontSize: '12',
                                padding: 0,
                                color: '#21BC9A',
                            },
                            yAxisIndex: 1,
                            data: balanceReceivableRate,
                        },
                    ],
                };
                this.initLineChart(data1);
                this.initLineChart(data2);
            }
        },

        // 获取数据    
        getSaledayApi() {
            const path = '/interfaceApi/report/data_express/get_receivable_month?beginTime='
            + this.date1 + '&endTime=' + this.date2 + '&pian_q_id=' + this.pian_q_id;
            return this.$axios.$get(path, { defEx: true });
        },

        confirmDate(value) {
            this.showCalendarPop = false;
            if (this.timeType === 1) {
                this.date1 = this.formatDate(value);
                const b = this.validateTime();
                if (b) {
                    this.date1 = this.formatDate(value);
                } else {
                    return;
                }
            } else {
                this.date2 = this.formatDate(value);
                const b = this.validateTime();
                if (b) {
                    this.date2 = this.formatDate(value);
                } else {
                    return;
                }
            }
            this.getSaleday();
        },
        // 判断时间区间结束日期必须大于开始日期，跨度不超过一年
        validateTime() {
            const startTmp = this.date1.split('-');
            const endTmp = this.date2.split('-');
            const sd = new Date(startTmp[0], startTmp[1], 1);
            const ed = new Date(endTmp[0], endTmp[1], 1);
            let b = false;
            if (sd.getTime() > ed.getTime()) {
                this.$toast('开始日期不能大于结束日期');
                b = false;
            } else {
                // eslint-disable-next-line radix
                const month1 = startTmp[0] * 12 + parseInt(startTmp[1]);
                // eslint-disable-next-line radix
                const month2 = endTmp[0] * 12 + parseInt(endTmp[1]);
                const m = Math.abs(month1 - month2);
                if (m > 12) {
                    this.$toast('时间跨度不能超过1年');
                    b = false;
                } else {
                    b = true;
                }
            }
            return b;
        },
        cancelDate() {
            this.showCalendarPop = false;
        },
        formatDate(date) {
            date = new Date(date);
            const y = date.getFullYear();
            let m = date.getMonth() + 1;
            m = m < 10 ? '0' + m : m;
            return y + '-' + m;
        },
        confirmOrg(value) {
            this.showOrgPop = false;
            this.orgName = '';
            if (value[0]) {
                this.orgName += value[0];
            }
            if (value[1] && value[1] !== '请选择') {
                this.orgName = value[1];
            }
            if (value[2] && value[2] !== '请选择') {
                this.orgName += '-' + value[2];
            }

            if (value[2] && value[2] !== '请选择') {
                this.orgData.map(item => {
                    if (item.children) {
                        item.children.map(v => {
                            if (v.text === value[2]) {
                                this.pian_q_id = v.dic_code;
                            }
                        });
                    }
                });
                this.yun_yq_id = '';
            } else if (value[1] && value[1] !== '请选择') {
                this.orgData.map(item => {
                    if (item.text === value[1]) {
                        this.pian_q_id = item.dic_code;
                    }
                });
            } else {
                this.pian_q_id = '';
            }
            this.getSaleday();
        },
        cancelOrg() {
            this.showOrgPop = false;
        },
        // 选中table行
        selectRow(index) {
            this.activeRow = index;
        },
        tabSelect() {},
        // 量价结构分析
        initLineChart(data) {
            const myChart = this.$echarts.init(document.getElementById(data.id));
            const option = {
                tooltip: {
                    trigger: 'axis',
                },
                legend: {
                    data: data.legend,
                },
                grid: data.grid,
                xAxis: [
                    {
                        type: 'category',
                        data: data.xData,
                        axisPointer: {
                            type: 'shadow',
                        },
                        // 设置间隔
                        axisLabel: {
                            interval: 0,
                            fontSize: 10, // 字体大小
                            rotate: 30,
                        },
                        // 设置边框样式
                        axisLine: {
                            lineStyle: {
                                color: '#979EA7',
                            },
                        },
                        splitLine: { show: false },
                        axisTick: { show: false },
                    },
                ],
                yAxis: [],
                series: data.series,
            };
            if (data) {
                data.yAxisName.forEach(item => {
                    option.yAxis.push({
                        name: item,
                        // 设置间隔
                        axisLabel: {
                            formatter: '{value}',
                            interval: 0,
                            fontSize: 12, // 字体大小
                        },
                        // 设置边框样式
                        axisLine: {
                            lineStyle: {
                                color: '#979EA7',
                            },
                        },
                        splitLine: {
                            show: true,
                            lineStyle: {
                                type: 'dashed',
                                color: '#F0F0F0',
                            },
                        },
                        axisTick: {
                            show: false,
                        },
                    },);
                });
            }
            myChart.setOption(option);
        },
    },
};
</script>
<style lang="stylus" scoped>
.accountsReceive
    background #fff
    width 100%
    height 100%
    .search-conditions-con
        padding 10rpx
        .search-conditions
            font-size 16rpx
            height 45rpx
            box-shadow 1px 1px 4px 0px rgba(0,0,0,0.2)
            border-radius 4rpx
            padding 10rpx 20rpx
            display flex
            justify-content space-around
            line-height 25rpx
            .time-con
                text-align center
                &.time-con2
                    position relative
                    padding-right 15rpx
                    &:after
                        content ''
                        position absolute
                        right 5rpx
                        height 15rpx
                        border-right 1px solid #D7D7D7
                        margin-top 5rpx
            .iconfont
                font-size 14rpx
                color #979EA7
                margin-left 5rpx
            .org
                text-align center
                width 160rpx
                .org-name
                    color #3495FB
    .main
        height calc(100% - 60rpx)
        overflow-y auto
        .top
            padding 0 10rpx 10rpx 10rpx
            h4
                margin-top 10rpx
                span
                    font-size 12rpx
                    color #979EA7
            .header
                display flex
                margin-top 10rpx
                .item
                    flex 1
                    flex-shrink 0
                    width 25%
                    text-align center
                    .describe
                        font-size 12rpx
                    .num
                        overflow hidden
                        text-overflow ellipsis
                        white-space nowrap
                    &.item0
                        .num
                            color #5588F1
                    &.item1
                        .num
                            color #FA8436
                    &.item2
                        .num
                            color #21BDCC
                    &.item3
                        .num
                            color #FFB729
            table
                width 100%
                border-spacing 0px
                border-collapse collapse
                margin-top 10rpx
                table-layout fixed
                th
                    background rgba(235,240,252,1)
                    height 45rpx
                    border 2.5rpx solid #fff
                    border-collapse collapse
                    font-size 14rpx
                    font-weight normal
                td
                    border 2.5rpx solid #fff
                    border-collapse collapse
                    height 45rpx
                    text-align center
                    width 40rpx
                    font-size 14rpx
                    background rgba(85,136,241,.04)
                    width 25%
                    color #5588F1
                    &.row-tit
                        color #333333
                        background rgba(235,240,252,1)
                tbody
                    tr
                        &.activeRow
                            td
                                background rgba(250,132,54,1)
                                box-shadow 1px 1px 4px 0px rgba(0,0,0,0.3)
                                color #fff
                            .row-tit
                                color #823802
                                background rgba(245,242,237,1)
                                box-shadow 1px 1px 4px 0px rgba(0,0,0,0.3)
                                border 1px solid rgba(222,227,239,1)
        .split
            background #F0F0F0
            height 15rpx
        .chart-con
            padding 10rpx
            h4
                margin 10rpx 0
            #lineChart
                height 235rpx
            #lineChart2
                height 235rpx
</style>